import {
  POLICY_TYPE_LIST,
  SOURCE_TYPE_LIST,
  FINANCE_ACCOUNT_TYPE_LIST,
  DELIVERY_MODE_LIST,
  LKBQ_LIST,
  K_FRAME_XZ_LIST,
  RETURN_POINT_GOODS_LIST,
  QDGS_LIST,
  REBATE_BOOL_LIST,
  CUSTOME_CLASSIFY_LIST,
  LL_PROVINCE_LIST,
  INVEST_LEVEL_LIST,
} from './constants/rebate';

export default {
  province: {
    name: 'province',
    title: '省',
    type: 'search',
    config: {
      placeholder: '请输入省',
    },
  },
  city: {
    name: 'city',
    title: '市',
    type: 'search',
    config: {
      placeholder: '请输入市',
    },
  },
  rebate_period: {
    name: 'period',
    title: '统计周期',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择统计周期',
    },
  },
  customer_name: {
    name: 'customer_name',
    title: '客户名称',
    type: 'search',
    config: {
      placeholder: '请输入客户名称',
    },
  },
  rebate_uid: {
    name: 'uid',
    title: 'UID',
    type: 'search',
    config: {
      placeholder: '请输入UID',
    },
  },
  service_provider_name: {
    name: 'service_provider_name',
    title: '服务商名称',
    type: 'search',
    config: {
      placeholder: '请输入服务商名称',
    },
  },
  service_parent_id: {
    name: 'service_parent_id',
    title: '服务商ID',
    type: 'search',
    config: {
      placeholder: '请输入服务商ID',
    },
  },
  uid_agent_uin: {
    name: 'uid_agent_uin',
    title: '客户集团标签',
    type: 'search',
    config: {
      placeholder: '请输入客户集团标签',
    },
  },
  policy_type: {
    name: 'policy_type',
    title: '政策类别',
    type: 'select',
    defaultValue: '1',
    config: {
      data: POLICY_TYPE_LIST,
    },
  },
  consume_source: {
    name: 'consume_source',
    title: '来源',
    type: 'select',
    config: {
      data: SOURCE_TYPE_LIST,
    },
  },
  account_type_name: {
    name: 'account_type_name',
    title: '资金账户类型',
    type: 'select',
    config: {
      data: FINANCE_ACCOUNT_TYPE_LIST,
      multiple: true,
    },
  },
  delivery_mode: {
    name: 'delivery_mode',
    title: '投放模式',
    type: 'select',
    config: {
      data: DELIVERY_MODE_LIST,
    },
  },
  lkbq: {
    name: 'lkbq',
    title: '累框标签',
    type: 'select',
    config: {
      data: LKBQ_LIST,
      multiple: true,
    },
  },
  return_point_goods: {
    name: 'return_point_goods',
    title: '返点/返货',
    type: 'select',
    config: {
      data: RETURN_POINT_GOODS_LIST,
    },
  },
  corporation_name: {
    name: 'corporation_name',
    title: '客户公司主体名称',
    type: 'search',
    config: {
      placeholder: '请输入客户公司主体名称',
    },
  },
  ad_loc: {
    name: 'ad_loc',
    title: '下单广告位名称',
    type: 'search',
    config: {
      placeholder: '请输入下单广告位名称',
    },
  },
  qdgs: {
    name: 'qdgs',
    title: '渠道归属',
    type: 'select',
    config: {
      data: QDGS_LIST,
    },
  },
  k_frame_xz: {
    name: 'k_frame_xz',
    title: 'k框修正列',
    type: 'select',
    config: {
      data: K_FRAME_XZ_LIST,
      multiple: true,
    },
  },
  policy_inner: {
    name: 'policy_inner',
    title: '政策内外',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  qk_hsxx: {
    name: 'qk_hsxx',
    title: '签框-核算信息',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  investment_year: {
    name: 'investment_year',
    title: '招商政策归属年份',
    type: 'select',
    config: {
      data: [],
      fetchData: () => new Promise((resolve) => {
        const initYear = 2020;
        let y = new Date().getFullYear() + 1;
        const yearList = [];
        while (y >= initYear) {
          yearList.push({ label: y, value: y });
          y -= 1;
        }
        resolve([
          { label: '全部', value: '' },
          ...yearList,
        ]);
      }),
    },
  },
  custome_classify: {
    name: 'custome_classify',
    title: '客户签约模式',
    type: 'select',
    config: {
      data: CUSTOME_CLASSIFY_LIST,
      multiple: true,
    },
  },
  new_cust_label: {
    name: 'new_cust_label',
    title: '新客标签',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  car_license: {
    name: 'car_license',
    title: '汽车牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  zsjm_license: {
    name: 'zsjm_license',
    title: '招商加盟牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  zyds_license: {
    name: 'zyds_license',
    title: '直营电商牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  fc_license: {
    name: 'fc_license',
    title: '房产牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  qy_license: {
    name: 'qy_license',
    title: '区域牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  qyzw_license: {
    name: 'qyzw_license',
    title: '区域政务牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  qylu_license: {
    name: 'qylu_license',
    title: '区域旅游牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  yys_license: {
    name: 'yys_license',
    title: '运营商牌照',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  ad_schedul_id: {
    name: 'ad_schedul_id',
    title: '广告排期ID',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
  },
  ll_province: {
    name: 'll_province',
    title: '累量省份',
    type: 'select',
    config: {
      data: LL_PROVINCE_LIST,
      multiple: true,
    },
  },
  sfps: {
    name: 'sfps',
    title: '是否品商',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  dwcl: {
    name: 'dwcl',
    title: '大网C类名单',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  consume_2000: {
    name: 'consume_2000',
    title: '2000万以上大客',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  sfpsyxtk: {
    name: 'sfpsyxtk',
    title: '是否品商有效拓客',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  sfppkh: {
    name: 'sfppkh',
    title: '是否品牌客户',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  sfpsgg: {
    name: 'sfpsgg',
    title: '是否品商广告',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  sfzmtsph: {
    name: 'sfzmtsph',
    title: '是否自媒体视频号',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  k1kjsd: {
    name: 'k1kjsd',
    title: 'k1框架赛道',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  bca_label: {
    name: 'bca_label',
    title: 'bca标签',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  ecology_label: {
    name: 'ecology_label',
    title: '生态标签',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  ecology_type: {
    name: 'ecology_type',
    title: '生态类型',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  interal_label: {
    name: 'interal_label',
    title: '内部客户标签',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  is_wgft: {
    name: 'is_wgft',
    title: '是否违规封停',
    type: 'select',
    config: {
      data: REBATE_BOOL_LIST,
    },
  },
  industry_first_label: {
    name: 'industry_first_label',
    title: '一级行业',
    type: 'search',
    config: {
      placeholder: '请输入一级行业',
    },
  },
  industry_second_label: {
    name: 'industry_second_label',
    title: '二级行业',
    type: 'search',
    config: {
      placeholder: '请输入二级行业',
    },
  },
  invest_level: {
    name: 'invest_level',
    title: '招商级别',
    type: 'select',
    config: {
      data: INVEST_LEVEL_LIST,
    },
  },
};
